import numeral from 'numeral';

export default (columnName, cellValue, isTotalRow = false) => {
  if (cellValue === null || cellValue === undefined) {
    return { value: ' ', classList: [] };
  }

  let value = cellValue;
  const classList = isTotalRow ? ['totalRowCell'] : ['cell'];

  if (!isTotalRow && columnName === 'portfolio') {
    classList.push('portfolio');
  }

  if (columnName.includes('Allocation') || columnName.includes('Performance')) {
    value = numeral(cellValue).format('0.00%');
    if (!isTotalRow && cellValue < 0) {
      classList.push('negative');
    }
  }

  if (columnName.includes('Investment') || columnName.includes('Pnl')) {
    value = numeral(cellValue).format('$0,0.00');
    if (!isTotalRow && cellValue < 0) {
      classList.push('negative');
    }
  }

  return { value, classList };
};
